"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var yin_1 = require("./detectors/yin");
exports.YIN = yin_1.YIN;
var amdf_1 = require("./detectors/amdf");
exports.AMDF = amdf_1.AMDF;
var acf2plus_1 = require("./detectors/acf2plus");
exports.ACF2PLUS = acf2plus_1.ACF2PLUS;
var dynamic_wavelet_1 = require("./detectors/dynamic_wavelet");
exports.DynamicWavelet = dynamic_wavelet_1.DynamicWavelet;
var macleod_1 = require("./detectors/macleod");
exports.Macleod = macleod_1.Macleod;
var frequencies_1 = require("./tools/frequencies");
exports.frequencies = frequencies_1.frequencies;
exports.default = {
  YIN: yin_1.YIN,
  AMDF: amdf_1.AMDF,
  ACF2PLUS: acf2plus_1.ACF2PLUS,
  DynamicWavelet: dynamic_wavelet_1.DynamicWavelet,
  Macleod: macleod_1.Macleod,
  frequencies: frequencies_1.frequencies
};